<template>
    <v-container>
        <v-card>
            <v-card-title>
                {{text.appTitle}}-{{text.administrator.title}}
            </v-card-title>
            <v-card-text>
                <v-tabs>
                    <v-tab href="#users" @click="getUserList">{{text.administrator.tabUsers}}</v-tab>
                    <v-tab href="#period" @click="getPeriodConfig">{{text.administrator.periodConfig}}</v-tab>
                    <v-tab href="#payResing" @click="getSalResings">{{text.resingForm.salary.title}}</v-tab>
                    <v-tab href="#views" @click="getViewCfg">{{text.administrator.viewConfig}}</v-tab>
                    <v-tab href="#forms" @click="getFormCfg">{{text.administrator.formConfig}}</v-tab>
                    <v-tab-item value="users">
                        <v-card>
                            <v-card-title>
                                <v-form ref="addUserForm"><v-row>
                                    <v-col class="d-flex flex-row">
                                        <v-text-field autocomplete="off" :label="text.administrator.listColumn.userId8" v-model="addUserId" :rules="[userId8Rule]" ></v-text-field>
                                        <v-btn @click="addUser" :disabled="disAddUserBtn">{{text.administrator.addUser}}</v-btn>
                                    </v-col>
                                </v-row></v-form>
                            </v-card-title>
                            <v-card-text>
                                <div>
                                    <v-btn @click="matchUser" :disabled="disAddUserBtn">{{text.administrator.matchData}}</v-btn>
                                    ※{{text.administrator.matchDataTxt}}
                                </div>
                                <v-menu v-model="userMenu.main" :position-x="userMenu.x" :position-y="userMenu.y" absolute>
                                    <v-list>
                                        <v-list-item-group>
                                        <v-list-item><span class="hoverPointer" @click="resetPassword()">{{text.administrator.reSetPassword}}</span></v-list-item>
                                        <v-list-item v-if="false"><span class="hoverPointer" @click="setfixName()">{{text.administrator.fixName}}</span></v-list-item>
                                        <v-list-item><span class="hoverPointer" @click="setAlias()">{{text.administrator.setAlias}}</span></v-list-item>
                                        </v-list-item-group>
                                    </v-list>
                                </v-menu>
                                <v-data-table dense :no-data-text="text.administrator.noData" :headers="userListHeder"
                                :items="userList" :search="userListFilter" @contextmenu:row="userListMenu">
                                    <template v-slot:top>
                                        <v-text-field v-model="userListFilter"></v-text-field>
                                    </template>
                                    <template v-slot:item._resetPassword="{item}">
                                        <v-btn @click="resetPassword(item)">{{text.administrator.reSetPassword}}</v-btn>
                                    </template>
                                </v-data-table>
                            </v-card-text>
                        </v-card>
                    </v-tab-item>
                    <v-tab-item value="period">
                        <v-card>
                            <v-container class="d-flex flex-row">
                                <v-menu v-model="datePick.a" :close-on-content-click="false">
                                    <template v-slot:activator="{ on, attrs }">
                                        <v-text-field style="max-width:15em" v-bind="attrs" v-on="on" v-model="periodConfig.saralyView" :label="text.administrator.period.saralyView" :hint="text.administrator.period.saralyViewHint" persistent-hint></v-text-field>
                                    </template>
                                    <v-date-picker no-title locale="ja" v-model="periodConfig.saralyView" type="date" @input="datePick.a=false"></v-date-picker>
                                </v-menu>
                                <v-btn v-show="false" @click="periodConfig.saralyView=getToday()">今日</v-btn>
                            </v-container>
                            <v-container class="d-flex flex-row">
                                <v-menu v-model="datePick.b" :close-on-content-click="false">
                                    <template v-slot:activator="{ on, attrs }">
                                        <v-text-field style="max-width:15em" v-bind="attrs" v-on="on" v-model="periodConfig.bounusView" :label="text.administrator.period.bounusView" :hint="text.administrator.period.saralyViewHint" persistent-hint></v-text-field>
                                    </template>
                                    <v-date-picker no-title locale="ja" v-model="periodConfig.bounusView" type="date" @input="datePick.a=false"></v-date-picker>
                                </v-menu>
                                <v-btn v-show="false" @click="periodConfig.bounusView=getToday()">今日</v-btn>
                            </v-container>
                            <v-container class="d-flex flex-row">
                                <v-menu v-model="datePick.c" :close-on-content-click="false">
                                    <template v-slot:activator="{ on, attrs }">
                                        <v-text-field style="max-width:15em" v-bind="attrs" v-on="on" v-model="periodConfig.yendView" :label="text.administrator.period.yendView" :hint="text.administrator.period.saralyViewHint" persistent-hint></v-text-field>
                                    </template>
                                    <v-date-picker no-title locale="ja" v-model="periodConfig.yendView" type="month" @input="datePick.a=false"></v-date-picker>
                                </v-menu>
                                <v-btn v-show="false" @click="periodConfig.yendView=getToday()">今日</v-btn>
                            </v-container>
                            <v-btn :disabled="disPeriodUpBtn" @click="updatePeriodConfig2">{{text.update}}</v-btn>
                            <v-divider></v-divider>
                            <v-text-field v-model="periodConfig.saraly" :label="text.administrator.period.saraly"></v-text-field>
                            <v-text-field v-model="periodConfig.retire" :label="text.administrator.period.retire"></v-text-field>
                            <v-text-field disabled v-model="periodConfig.yend" :label="text.administrator.period.yend"></v-text-field>
                            <v-btn :disabled="disPeriodUpBtn" @click="updatePeriodConfig">{{text.update}}</v-btn>
                        </v-card>
                    </v-tab-item>
                    <v-tab-item value="payResing">
                        <div>
                            <v-btn @click="digUploadResignList=true">{{text.resingForm.system.upload}}</v-btn>
                            <v-btn @click="digRemoveResignList=true">{{text.resingForm.system.remove}}</v-btn>
                        </div>
                        <div>
                            <v-simple-table>
                                <thead>
                                    <tr>
                                        <th>{{text.resingForm.system.aDate}}</th>
                                        <th>{{text.resingForm.system.rDate}}</th>
                                        <th>{{text.pCode}}</th>
                                        <th>{{text.shimei}}</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-for="srd in saralyResinList" :key="srd.userId">
                                        <td>{{srd.aDate}}</td>
                                        <td>{{srd.rDate}}</td>
                                        <td>{{srd.userId}}</td>
                                        <td>{{srd.userName}}</td>
                                    </tr>
                                </tbody>
                            </v-simple-table>
                        </div>
                    </v-tab-item>
                    <v-tab-item value="views">
                        <v-card>
                            <v-card-title>{{text.administrator.viewConfig}}</v-card-title>
                            <v-card-subtitle>
                                <v-select :items="viewConfig.selectList" v-model="viewConfig.selectItem" @change="selectViewItem"></v-select>
                            </v-card-subtitle>
                            <v-card-text>
                                <v-container v-show="viewConfig.fromView">
                                    <v-card outlined v-for="item in viewConfig.curCfg" :key="item._key">
                                        <v-card-title><v-text-field dense v-model="item.title" :label="text.administrator.titile" outlined></v-text-field>
                                        <v-icon @click="moveOrder(-1,item._key)">mdi-arrow-up-bold</v-icon>
                                        <v-icon @click="moveOrder(1,item._key)">mdi-arrow-down-bold</v-icon>
                                        <v-spacer></v-spacer><v-icon @click="removeViewItem(item._key)">mdi-card-remove-outline</v-icon></v-card-title>
                                        <v-card-text>
                                            <div class="d-flex justify-center">
                                                <v-container>
                                                    <v-card outlined v-for="subItem in item.cards" :key="subItem._key">
                                                        <v-card-title>
                                                            <v-text-field dense v-model="subItem.title"  :label="text.administrator.titile" outlined></v-text-field>
                                                            <v-icon @click="moveOrder(-1,subItem._key)">mdi-arrow-up-bold</v-icon>
                                                            <v-icon @click="moveOrder(1,subItem._key)">mdi-arrow-down-bold</v-icon>
                                                            <v-spacer></v-spacer><v-icon @click="removeViewItem(subItem._key)">mdi-card-remove-outline</v-icon>
                                                        </v-card-title>
                                                        <v-card-text>
                                                            <div v-show="!subItem._child"><v-row class="d-flex justify-start">
                                                                <v-select outlined dense v-model="subItem.itemCode" :items="viewConfig.tpDefitemName" :label="text.administrator.tpDef"></v-select>
                                                                <v-checkbox dense v-model="subItem._calc" :label="text.administrator.calc" class="d-flex align-center"></v-checkbox>
                                                                <div v-if="subItem._calc && subItem.calc">
                                                                    <v-select dense :items="viewConfig.calcTypes" class="d-flex align-center" style="min-width:4em;max-width:6em" v-show="subItem._calc" tile outlined v-model="subItem.calc.type"></v-select>
                                                                    <div class="d-flex flex-row">
                                                                        <v-switch dense v-model="subItem.calc._def"></v-switch>
                                                                        <div v-show="subItem.calc._def"><v-select dense class="flex-grow-1 d-flex align-center" tile outlined v-model="subItem.calc.itemCode" :items="viewConfig.tpDefitemName" :label="text.administrator.tpDef"></v-select></div>
                                                                        <div v-show="!subItem.calc._def"><v-text-field dense class="flex-grow-1 d-flex align-center" style="max-width:4em" tile outlined v-model="subItem.calc.num" :label="text.numlic"></v-text-field></div>
                                                                    </div>
                                                                    <div v-if="subItem.calc.value" v-show="subItem.calc.type==='='||subItem.calc.type==='?'||subItem.calc.type==='.'"><v-text-field dense class="flex-grow-1 d-flex align-center" tile outlined v-model="subItem.calc.value.t" :label="text.administrator.option.tvalue"></v-text-field></div>
                                                                    <div v-if="subItem.calc.value" v-show="subItem.calc.type==='='||subItem.calc.type==='?'"><v-text-field dense class="flex-grow-1 d-flex align-center" tile outlined v-model="subItem.calc.value.f" :label="text.administrator.option.fvalue"></v-text-field></div>
                                                                    <div class="d-flex flex-row">
                                                                        <v-checkbox dense v-model="subItem.calc._calc" :label="text.administrator.calc" class="d-flex align-center" @click="!subItem.calc.calc?subItem.calc.calc={type:null}:null"></v-checkbox>
                                                                        <div v-if="subItem.calc._calc" class="d-flex flex-row">
                                                                            <v-select dense :items="viewConfig.calcTypes" class="d-flex align-center" style="min-width:4em;max-width:6em" tile outlined v-model="subItem.calc.calc.type" @change="refreshViewConfig"></v-select>
                                                                            <v-text-field dense class="flex-grow-1 d-flex align-center" style="max-width:4em" tile outlined v-model="subItem.calc.calc.num" :label="text.numlic"></v-text-field>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </v-row></div>
                                                            <v-card v-show="subItem._child" v-for="childItem in subItem.children" :key="childItem._key">
                                                                <v-card-title>
                                                                    <v-text-field dense v-model="childItem.title" :label="text.administrator.titile" outlined></v-text-field>
                                                                    <v-icon @click="moveOrder(-1,childItem._key)">mdi-arrow-up-bold</v-icon>
                                                                    <v-icon @click="moveOrder(1,childItem._key)">mdi-arrow-down-bold</v-icon>
                                                                    <v-spacer></v-spacer><v-icon  @click="removeViewItem(childItem._key)">mdi-card-remove-outline</v-icon>
                                                                </v-card-title>
                                                                <v-card-text>
                                                                    <v-row class="d-flex justify-start">
                                                                        <v-select class="flex-grow-1 d-flex align-center" tile outlined dense v-model="childItem.itemCode" :items="viewConfig.tpDefitemName" :label="text.administrator.tpDef"></v-select>
                                                                        <v-checkbox dense v-model="childItem._calc" :label="text.administrator.calc" class="d-flex align-center"></v-checkbox>
                                                                        <div v-if="childItem._calc && childItem.calc">
                                                                            <v-select dense :items="viewConfig.calcTypes" class="d-flex align-center" style="min-width:4em;max-width:6em" v-show="childItem._calc" tile outlined v-model="childItem.calc.type" @change="refreshViewConfig"></v-select>
                                                                            <div class="d-flex flex-row">
                                                                                <v-switch dense v-model="childItem.calc._def"></v-switch>
                                                                                <div v-show="childItem.calc._def"><v-select dense class="flex-grow-1 d-flex align-center" tile outlined v-model="childItem.calc.itemCode" :items="viewConfig.tpDefitemName" :label="text.administrator.tpDef"></v-select></div>
                                                                                <div v-show="!childItem.calc._def"><v-text-field dense class="flex-grow-1 d-flex align-center" style="max-width:4em" tile outlined v-model="childItem.calc.num" :label="text.numlic"></v-text-field></div>
                                                                            </div>
                                                                            <div v-show="childItem.calc.type==='='||childItem.calc.type==='?'||subItem?.calc?.type==='.'"><v-text-field dense class="flex-grow-1 d-flex align-center" tile outlined v-model="childItem.calc.value.t" :label="text.administrator.option.tvalue"></v-text-field></div>
                                                                            <div v-show="childItem.calc.type==='='||childItem.calc.type==='?'"><v-text-field dense class="flex-grow-1 d-flex align-center" tile outlined v-model="childItem.calc.value.f" :label="text.administrator.option.fvalue"></v-text-field></div>
                                                                            <div class="d-flex flex-row">
                                                                                <v-checkbox dense v-model="childItem.calc._calc" :label="text.administrator.calc" class="d-flex align-center"></v-checkbox>
                                                                                <div v-if="childItem.calc._calc">
                                                                                    <v-select dense :items="viewConfig.calcTypes" class="d-flex align-center" style="min-width:4em;max-width:6em" tile outlined v-model="childItem.calc.calc.type" @change="refreshViewConfig"></v-select>
                                                                                    <v-text-field dense class="flex-grow-1 d-flex align-center" style="max-width:4em" tile outlined v-model="childItem.calc.calc.num" :label="text.numlic"></v-text-field>
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                    </v-row>
                                                                </v-card-text>
                                                            </v-card>
                                                                <v-card outlined>
                                                                    <v-card-title>
                                                                        <v-spacer></v-spacer>
                                                                        <v-icon @click="addViewItem(subItem._key)">mdi-card-plus-outline</v-icon>
                                                                    </v-card-title>
                                                                </v-card>
                                                        </v-card-text>
                                                        <v-divider></v-divider>
                                                    </v-card>
                                                    <v-card outlined>
                                                        <v-card-title>
                                                            <v-spacer></v-spacer>
                                                            <v-icon @click="addViewItem(item._key)">mdi-card-plus-outline</v-icon>
                                                        </v-card-title>
                                                    </v-card>
                                                </v-container>
                                            </div>
                                        </v-card-text>
                                        <v-divider></v-divider>
                                    </v-card>
                                    <v-card outlined>
                                        <v-card-title><v-spacer></v-spacer> <v-icon @click="addViewItem()">mdi-card-plus-outline</v-icon></v-card-title>
                                    </v-card>
                                </v-container>
                            </v-card-text>
                            <v-card-actions>
                                <v-btn @click="viewUpdate" :disabled="viewConfig.disUpdateBtn">{{text.update}}</v-btn>
                            </v-card-actions>
                        </v-card>
                    </v-tab-item>
                    <v-tab-item value="forms">
                        <v-card>
                            <v-card-title>{{text.administrator.formConfig}}</v-card-title>
                            <v-card-subtitle>
                                <v-select :items="formConfig.selectList" v-model="formConfig.selectItem" @change="selectFormItem"></v-select>
                            </v-card-subtitle>
                            <v-card-text>
                                <v-container v-show="formConfig.fromView">
                                    <v-container>
                                        <v-btn @click="getPdf">{{text.administrator.getPdf}}</v-btn>
                                        <div class="d-flex flex-row">
                                            <v-file-input @change="selectFile" v-model="tempPdfObj"></v-file-input>
                                            <v-btn @click="uploadPdf" :disabled="disUploadBtn">{{text.administrator.pdfUpload}}</v-btn>
                                        </div>
                                        <v-btn @click="disTempPdf" :disabled="disAppPdfBtn">{{text.administrator.disTmpPdf}}</v-btn>
                                    </v-container>
                                    <v-simple-table>
                                        <thead>
                                            <tr class="ma-0 pa-0">
                                                <th class="ma-0 pa-0">{{text.administrator.formColumn.defcode}}</th>
                                                <th class="ma-0 pa-0">{{text.administrator.formColumn.pX}}</th>
                                                <th class="ma-0 pa-0">{{text.administrator.formColumn.pY}}</th>
                                                <th class="ma-0 pa-0">{{text.administrator.formColumn.width}}</th>
                                                <th class="ma-0 pa-0">{{text.administrator.formColumn.height}}</th>
                                                <th class="ma-0 pa-0">{{text.administrator.formColumn.fSize}}</th>
                                                <th class="ma-0 pa-0">{{text.administrator.formColumn.align}}</th>
                                                <th class="ma-0 pa-0">{{text.administrator.formColumn.previewVal}}</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr v-for="formData of formConfig.colomun" :key="formData._key"  class="ma-0 pa-0">
                                                <th>
                                                    <v-container>
                                                    <div class="d-flex flex-row">
                                                        <v-icon @click="removeFormItem(formData._key)">mdi-card-remove-outline</v-icon>
                                                        <v-select dense outlined :items="formConfig.tpDefitemName" v-model="formData.TABLE_ITEM_NO" :label="text.administrator.tpDef"></v-select>
                                                        code:{{ formData.TABLE_ITEM_NO }}
                                                    </div>
                                                    <div class="d-flex flex-row">
                                                        <div class="d-flex flex-column">
                                                            <div class="d-flex flex-row">
                                                                <v-checkbox v-model="formData._options"></v-checkbox>
                                                                <div class="d-flex flex-column" v-if="formData.OPTIONS">
                                                                    <v-select :label="text.administrator.option.type" v-if="formData._options" style="max-width:4em" dense outlined :items="formConfig.calcTypes" v-model="formData.OPTIONS[0].type"></v-select>
                                                                    <div  class="d-flex flex-row">
                                                                        <v-switch dense v-model="formData.OPTIONS[0]._def"></v-switch>
                                                                        <v-select v-show="formData.OPTIONS[0]._def" :label="text.administrator.tpDef" v-if="formData._options&&(formData.OPTIONS[0].type!=='?'&&formData.OPTIONS[0].type!=='=')" style="max-width:8em" dense outlined :items="formConfig.tpDefitemName" v-model="formData.OPTIONS[0].itemCode"></v-select>
                                                                        <v-text-field v-show="!formData.OPTIONS[0]._def" :label="text.administrator.option.num" v-if="formData._options&&formData.OPTIONS[0].type!=='='" style="max-width:4em" dense outlined v-model="formData.OPTIONS[0].num"></v-text-field>
                                                                    </div>
                                                                    <div  class="d-flex flex-row">
                                                                        <v-text-field :label="text.administrator.option.tvalue" v-if="formData.OPTIONS[0].value && formData.OPTIONS[0].type==='?'||formData.OPTIONS[0].type==='='" style="max-width:12em" dense outlined v-model="formData.OPTIONS[0].value.t"></v-text-field>
                                                                        <!--v-text-field :label="text.administrator.option.tvalue" v-if="formData.OPTIONS[0].type==='?'" style="max-width:4em" dense outlined v-model="formData.OPTIONS[0].value.t"></v-text-field-->
                                                                        <v-text-field :label="text.administrator.option.fvalue" v-if="formData.OPTIONS[0].value && formData.OPTIONS[0].type==='?'" style="max-width:12em" dense outlined v-model="formData.OPTIONS[0].value.f"></v-text-field>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                            <div class="d-flex flex-row" v-if="formData._options && formData.OPTIONS">
                                                                <v-checkbox v-model="formData.OPTIONS[0]._calc" @click="!formData.OPTIONS[1]?formData.OPTIONS[1]={}:null"></v-checkbox>
                                                                <div class="d-flex flex-column" v-if="formData.OPTIONS[0]._calc">
                                                                    <v-select :label="text.administrator.option.type" v-if="formData._options" style="max-width:4em" dense outlined :items="formConfig.calcTypes" v-model="formData.OPTIONS[1].type"></v-select>
                                                                    <div class="d-flex flex-row">
                                                                        <v-switch dense v-model="formData.OPTIONS[1]._def"></v-switch>
                                                                        <v-select v-show="formData.OPTIONS[1]._def" :label="text.administrator.tpDef" v-if="formData._options&&(formData.OPTIONS[1].type!=='?'&&formData.OPTIONS[0].type!=='=')" style="max-width:8em" dense outlined :items="formConfig.tpDefitemName" v-model="formData.OPTIONS[0].itemCode"></v-select>
                                                                        <v-text-field v-show="!formData.OPTIONS[1]._def" :label="text.administrator.option.num" v-if="formData._options&&formData.OPTIONS[1].type!=='='" style="max-width:4em" dense outlined v-model="formData.OPTIONS[1].num"></v-text-field>
                                                                    </div>
                                                                    <div  class="d-flex flex-row">
                                                                        <v-text-field :label="text.administrator.option.tvalue" v-if="formData.OPTIONS[1].type==='?'||formData.OPTIONS[1].type==='='" style="max-width:12em" dense outlined v-model="formData.OPTIONS[1].value.t"></v-text-field>
                                                                        <!--v-text-field :label="text.administrator.option.tvalue" v-if="formData.OPTIONS[0].type==='?'" style="max-width:4em" dense outlined v-model="formData.OPTIONS[0].value.t"></v-text-field-->
                                                                        <v-text-field :label="text.administrator.option.fvalue" v-if="formData.OPTIONS[1].type==='?'" style="max-width:12em" dense outlined v-model="formData.OPTIONS[1].value.f"></v-text-field>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div class="d-flex flex-row">
                                                        <v-card-title><v-spacer></v-spacer><v-icon @click="addFormItem(formData._key)">mdi-card-plus-outline</v-icon></v-card-title>
                                                    </div>
                                                    </v-container>
                                                </th>
                                                <th class="ma-0 pa-0"><v-text-field v-model="formData.POS_X" dense outlined style="max-width:6em" :label="text.administrator.formColumn.pX"></v-text-field></th>
                                                <th class="ma-0 pa-0"><v-text-field v-model="formData.POS_Y" dense outlined style="max-width:6em" :label="text.administrator.formColumn.pY"></v-text-field></th>
                                                <th class="ma-0 pa-0"><v-text-field  class="ma-0 pa-0" v-model="formData.WIDTH" dense outlined style="max-width:6em" :label="text.administrator.formColumn.width"></v-text-field></th>
                                                <th class="ma-0 pa-0"><v-text-field v-model="formData.HEIGHT" dense outlined style="max-width:6em" :label="text.administrator.formColumn.height"></v-text-field></th>
                                                <th class="ma-0 pa-0"><v-text-field v-model="formData.FONT_SIZE" dense outlined style="max-width:6em" :label="text.administrator.formColumn.fSize"></v-text-field></th>
                                                <th class="ma-0 pa-0"><v-select v-model="formData.ALIGN" :items="formConfig.alignItem" outlined dense style="max-width:6em" :label="text.administrator.formColumn.align"></v-select></th>
                                                <th class="ma-0 pa-0"><v-text-field v-model="formData._preView" dense outlined style="max-width:6em" :label="text.administrator.formColumn.previewVal"></v-text-field></th>
                                            </tr>
                                        </tbody>
                                        <thead>
                                            <tr>
                                                <th><v-icon @click="addFormItem(null)">mdi-card-plus-outline</v-icon></th>
                                            </tr>
                                        </thead>
                                    </v-simple-table>
                                </v-container>
                            </v-card-text>
                            <v-card-actions>
                                <v-btn @click="formPreview" :disabled="formConfig.disUpdateBtn">{{text.administrator.preview}}</v-btn>
                                <v-btn @click="formUpdate" :disabled="formConfig.disUpdateBtn">{{text.update}}</v-btn>
                            </v-card-actions>
                        </v-card>
                    </v-tab-item>
                </v-tabs>
            </v-card-text>
        </v-card>
        <v-dialog persistent v-model="digAddUserConf" max-width="500">
            <v-card>
                <v-card-title></v-card-title>
                <v-card-text>
                    <div v-show="warnMultiUser">
                        <v-alert type="warning">{{text.messege.warnMultiUser}}</v-alert>
                        {{text.messege.selectUser}}<br>
                        <v-select autocomplete="off" :items="selectUsers" @change="selectUser" v-model="selectUserNo"></v-select>
                    </div>
                    {{text.administrator.listColumn.userId}}:{{addUserInfo.userId}}<br>
                    {{text.administrator.listColumn.userName}}:{{addUserInfo.userName}}<br>
                    {{text.administrator.listColumn.depertment}}:{{addUserInfo.depertment}}<br>
                    {{text.administrator.listColumn.empCode}}:{{addUserInfo.empCode}}<br>
                </v-card-text>
                <v-card-actions>
                    <v-container>
                        <v-row>
                            {{text.administrator.confAddUser}}
                        </v-row>
                        <v-row>
                            <v-btn @click="addUserExec">{{text.yes}}</v-btn>
                            <v-btn @click="digAddUserConf = false">{{text.no}}</v-btn>
                        </v-row>
                    </v-container>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <v-dialog persistent v-model="digPassword" max-width="500">
            <v-card>
                <v-card-title>{{text.administrator.setNewPassword}}</v-card-title>
                <v-card-text>
                    {{text.administrator.listColumn.userId}}:{{addUserInfo.userId}}<br>
                    {{text.administrator.listColumn.userName}}:{{addUserInfo.userName}}<br>
                    {{text.password}}:<br>
                    <span class="text-h3">{{addUserInfo.password}}</span>
                    <v-divider></v-divider>
                    <v-btn @click="printPassword">{{text.administrator.printPdf}}</v-btn>
                </v-card-text>
                <v-card-actions>
                    <v-container>
                        <v-btn @click="digPassword = false">{{text.ok}}</v-btn>
                    </v-container>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <v-dialog persistent v-model="digPasswordRest" max-width="500">
            <v-card>
                <v-card-title>{{text.administrator.reSetPassword}}</v-card-title>
                <v-card-text>
                    {{text.administrator.listColumn.userId}}:{{addUserInfo.userId}}<br>
                    {{text.administrator.listColumn.userName}}:{{addUserInfo.userName}}<br>
                    {{text.administrator.listColumn.depertment}}:{{addUserInfo.depertment}}<br>
                </v-card-text>
                <v-card-actions>
                    <v-container>
                        <v-row>
                            {{text.administrator.confResetPssword}}
                        </v-row>
                        <v-row>
                            <v-btn @click="resetPasswordExec">{{text.yes}}</v-btn>
                            <v-btn @click="digPasswordRest = false">{{text.no}}</v-btn>
                        </v-row>
                    </v-container>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <v-dialog persistent v-model="digMigration" max-width="500">
            <v-card>
                <v-card-title>{{text.administrator.setAlias}}</v-card-title>
                <v-card-text>
                    {{text.administrator.listColumn.userId}}:{{userMenu.userItem.userid}}<br>
                    {{text.administrator.listColumn.userName}}:{{userMenu.userItem.username}}<br>
                    {{text.administrator.listColumn.empCode}}:{{userMenu.userItem.empcode}}<br>
                    <v-divider></v-divider>
                    {{text.messege.setAliasTxt.a}}<br>
                    {{text.messege.setAliasTxt.b}}<br>
                    {{text.messege.setAliasTxt.c}}<br>
                    {{text.messege.setAliasTxt.d}}<br>
                    <v-divider></v-divider>
                    <v-container>
                        <div class="d-flex flex-row">
                            <v-text-field ref="aliasUserForm" :label="text.new+text.administrator.listColumn.userId8" v-model="aliUserId" :rules="[userId8Rule]"></v-text-field>
                            <v-btn @click="getAliasUserInfo" :disabled="disAddUserBtn">{{text.serch}}</v-btn>
                        </div>
                    </v-container>
                    {{text.administrator.listColumn.userId}}:{{addUserInfo.userId}}<br>
                    {{text.administrator.listColumn.userName}}:{{addUserInfo.userName}}<br>
                    {{text.administrator.listColumn.depertment}}:{{addUserInfo.depertment}}<br>
                    {{text.administrator.listColumn.empCode}}:{{addUserInfo.empCode}}<br>
                </v-card-text>
                <v-card-actions>
                    <v-container>
                        <v-row>
                            {{text.messege.setAliasTxt.e}}
                        </v-row>
                        <v-row>
                            <v-btn @click="migraUserExec" :disabled="disMigBtn">{{text.yes}}</v-btn>
                            <v-btn @click="digMigration = false">{{text.no}}</v-btn>
                        </v-row>
                    </v-container>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <v-dialog v-model="digFixName" max-width="500">
            <v-card>
                <v-card-title>{{text.administrator.fixName}}</v-card-title>
                <v-card-text>
                    {{text.administrator.listColumn.userId}}:{{userMenu.userItem.userid}}<br>
                    {{text.administrator.listColumn.userName}}:{{userMenu.userItem.username}}<br>
                    {{text.administrator.listColumn.empCode}}:{{userMenu.userItem.empcode}}<br>
                    <v-divider></v-divider>
                    {{text.messege.fixName.a}}<br>
                    {{text.messege.fixName.b}}<br>
                </v-card-text>
                <v-card-actions>
                    <div class="d-flex flex-column">
                        <v-text-field :label="text.userName" v-model="fixName"></v-text-field>
                        <v-btn @click="fixNameExec(true)">{{text.messege.fixName.submit}}</v-btn>
                        <v-divider></v-divider>
                        <v-btn @click="fixNameExec(false)">{{text.messege.fixName.cancel}}</v-btn>
                        {{text.messege.fixName.cancelTxt}}
                    </div>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <v-dialog v-model="digUploadResignList" max-width="500" persistent>
            <v-card>
                <v-card-title>{{text.resingForm.system.upload}}</v-card-title>
                <v-card-text>
                    <div>
                        <span>{{text.messege.resing.upload1}}</span>
                        <v-file-input @change="setUploadFile" accept=".xlsx,.xlsm,.xls"></v-file-input>
                        <v-alert v-show="uploadWarnFlg" :type="uploadWarnTyp">{{uploadWarnMes}}</v-alert>
                        <v-checkbox :label="text.messege.resing.upload2" v-model="resignOverwrite"></v-checkbox>
                        <div>
                            <v-menu v-model="saralyDatePik.a" :close-on-content-click="false">
                                <template v-slot:activator="{ on, attrs }">
                                    <v-text-field @change="chkUploadBtnEnable" style="max-width:15em" v-bind="attrs" v-on="on" v-model="saralyResinDate.a" :label="text.messege.resing.uploadDateA"></v-text-field>
                                </template>
                                <v-date-picker no-title locale="ja" v-model="saralyResinDate.a" type="month" @input="saralyDatePik.a=false;chkUploadBtnEnable()"></v-date-picker>
                            </v-menu>
                        </div>
                        <div>
                            <v-menu v-model="saralyDatePik.r" :close-on-content-click="false">
                                <template v-slot:activator="{ on, attrs }">
                                    <v-text-field @change="chkUploadBtnEnable" style="max-width:15em" v-bind="attrs" v-on="on" v-model="saralyResinDate.r" :label="text.messege.resing.uploadDateR"></v-text-field>
                                </template>
                                <v-date-picker no-title locale="ja" v-model="saralyResinDate.r" type="date" @input="saralyDatePik.r=false;chkUploadBtnEnable()"></v-date-picker>
                            </v-menu>
                        </div>
                        <v-btn :disabled="disResignUploadBtn" @click="resignUpload">{{resingXlsxDig.uploadbtntxt}}</v-btn>
                    </div>
                </v-card-text>
                <v-card-actions>
                    <v-btn @click="digUploadResignList=false" :disabled="resingXlsxDig.disCancl">{{text.cancel}}</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <v-dialog v-model="digRemoveResignList" max-width="500" persistent>
            <v-card>
                <v-card-title>{{text.resingForm.system.remove}}</v-card-title>
                <v-card-text>{{text.messege.resing.remove}}
                </v-card-text>
                <v-card-actions>
                    <v-btn @click="execResignDelete">{{text.yes}}</v-btn>
                    <v-btn @click="digRemoveResignList=false">{{text.cancel}}</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <v-dialog v-model="digMatchuserWarrning" max-width="500" persistent>
            <v-card>
                <v-card-title>{{text.matchUserWarrning.title}}</v-card-title>
                <v-card-text>
                    {{text.matchUserWarrning.message1}}<br>
                    {{ text.matchUserWarrning.message2 }}
                </v-card-text>
                <v-card-actions>
                    <v-btn @click="execMatchUser">{{text.yes}}</v-btn>
                    <v-btn @click="digMatchuserWarrning=false">{{text.cancel}}</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </v-container>
</template>

<script lang="ts">
    import Vue from 'vue';
    import {DataTableItemProps} from "vuetify";
    import lang from "../lang";
    let text = new lang(0);
    import {apiRequest} from "../lib/api";
    import {SalaAPI_ModUser_req,DefnameTable,viewDegin,SalaAPI_column_Res,DB_TB_SALA_RESIGN,ViewDeginDetail} from "../lib/api/api_response_type"
    import * as comm from '../common';
    import * as type from '../types';
    import {getAddDef} from '../addsDef';
    import {importSalaryResign} from "../resingImport";
    import exceljs from "exceljs";
    interface vueRefForm extends Vue{
        validate:()=>boolean;
    }

    export default Vue.extend({
        components:{},
        data: () => ({
            text : text.Text,
            item:"",
            userListFilter:"",
            addUserId:"",
            fixName:"",
            disAddUserBtn:false,
            warnMultiUser:false,
            digAddUserConf:false,
            digPassword:false,
            digPasswordRest:false,
            digMigration:false,
            digFixName:false,
            digUploadResignList:false,
            digRemoveResignList:false,
            digMatchuserWarrning:false,
            disMigBtn:true,
            disFormUpdateBtn:false,
            disUploadBtn:true,
            disAppPdfBtn:true,
            disPeriodUpBtn:false,
            disResignUploadBtn:true,
            tempPdfObj:null,
            tempPdfFile:"",
            userListHeder:[
                {text:text.Text.administrator.listColumn.userId,value:"userid"},
                {text:text.Text.administrator.listColumn.userName,value:"username"},
                {text:text.Text.administrator.listColumn.depertment,value:"depname"},
                {text:text.Text.administrator.listColumn.empCode,value:"empcode"},
                {text:text.Text.administrator.listColumn.alias,value:"alias"},
                {text:text.Text.administrator.listColumn.isRetire,value:"retire"},
                {text:text.Text.administrator.listColumn.useTotp,value:"_otp"},
                {text:text.Text.administrator.listColumn.lastLogin,value:"lastLogin"},
            ],
            addUserInfo:{
                userId:"",
                userName:"",
                empCode:"",
                depnameShrt:"" as string|null,
                depertment:"" as string | null,
                depcode:"" as string |null,
                password:"",
            },
            selectUserNo:null as null|number,
            selectUsers:[] as Array<{value:string,text:string}>,
            userList:[] as Array<type.apiResponseData_user&{"_otp":string}>,
            timeProUserList:[] as type.apiResponseData_timeProUsers,
            aliUserId:"",
            userMenu:{
                main:false,
                x:0,
                y:0,
                userItem:{} as type.apiResponseData_user&{"_otp":string},
            },
            viewConfig:{
                selectList:[] as Array<{value:string,text:string}>,
                calcTypes:[{"value":"+","text":"+"},{"value":"-","text":"-"},{"value":"*","text":"*"},{"value":"/","text":"/"},{"value":"?","text":"?"},{"value":"=","text":"="},{"value":".","text":"."}] as Array<{value:string,text:string}>,
                selectItem:null as null|DefnameTable,
                disUpdateBtn:true,
                curCfg:[] as Array<ViewDeginDetail>,
                tpDefitemName:[] as Array<{value:number,text:string}>,
                keyCounter:0,
                formRender:false,
                fromView:false,
            },
            formConfig:{
                selectList:[] as Array<{value:string,text:string}>,
                calcTypes:[{"value":"+","text":"+"},{"value":"-","text":"-"},{"value":"*","text":"*"},{"value":"/","text":"/"},{"value":"?","text":"?"},{"value":"=","text":"="},{"value":".","text":"."}] as Array<{value:string,text:string}>,
                alignItem:[{"value":null,"text":""},{"value":"center","text":"center"},{"value":"right","text":"right"},{"value":"left","text":"left"}] as Array<{value:string,text:string}>,
                selectItem:null as null|DefnameTable,
                disUpdateBtn:true,
                colomun:[] as Array<type.db_TB_FORM_COLUMN&{_preView:string|number,_options:boolean,_key:number}>,
                form:null as type.db_TB_FORM|null,
                tpDefitemName:[] as Array<{value:number,text:string}>,
                keyCounter:0,
                formRender:false,
                fromView:false,
            },
            uploadFile:null as File|null,
            periodConfig:{
                saraly:0,
                retire:0,
                yend:0,
                saralyView:"",
                bounusView:"",
                yendView:"",
            },
            datePick:{
                a:false,
                b:false,
                c:false,
            },
            saralyResinList:[] as type.saralyResinDetail[],
            saralyResinUploadBook:null as null|exceljs.Workbook,
            saralyResinUploadData:null as null|Array<DB_TB_SALA_RESIGN>,
            resignOverwrite:true,
            saralyDatePik:{
                a:false,
                b:false,
                r:false,
            },
            saralyResinDate:{
                a:"",
                r:"",
            },
            uploadWarnFlg:false,
            uploadWarnTyp:null as "success"|"info"|"warning"|"error"|null,
            uploadWarnMes:"",
            userId8Rule:(value:string)=> value.length === 8 || text.Text.messege.userId8,
            resingXlsxDig:{
                uploadbtntxt:text.Text.messege.resing.upload3,
                disCancl:false,
            },
            api:null as null|{connection:boolean,apiRequest:null|apiRequest},
        }),
        mounted() {
            this.api = this.$store.state.apiSaver;
        },
        updated(){
            if(this.viewConfig.formRender){
                comm.LoadingOverlay(this,false);
                this.viewConfig.formRender = false;
                this.viewConfig.fromView = true;
                this.viewConfig.disUpdateBtn = false;
            }
        },
        methods:{
            reset(){
                //@ts-ignore
                Object.assign(this.$data,this.$options.data());
            },
            async getUserList(){
                if(this.api && this.api.connection && this.api.apiRequest){
                    const apiResponse = await this.api.apiRequest.request.admin.getUsers({"containRetired":true});
                    if(apiResponse.statusCode === 200){
                        this.userList = apiResponse.data.map(v=>{
                            return {
                                "userid":v.userid,
                                "username":v.username,
                                "empcode":v.empcode,
                                "_otp":v.useOtp?this.text.otpActive:"",
                                "lastLogin":v.lastLogin?comm.formatDate(new Date(v.lastLogin),"mm/dd HH:MM:SS"):"",
                                "alias":v.alias,
                                "retire":v.retire?comm.formatDate(new Date(v.retire),"yyyy/mm/dd"):"",
                                "useOtp":v.useOtp,
                                "depname":v.depname,
                            }
                        });
                    }else if(apiResponse.statusCode === 401){
                        comm.invalidSession(this);
                    }else{
                        comm.ApiErrorMessege(this,comm.unknowError,true);
                    }
                }
            },
            /*
            async getTimeProUserList(){
                if(this.api && this.api.connection && this.api.apiRequest){
                    const apiResponse = await this.api.apiRequest.request.admin.getTimeProUsers();
                    if(apiResponse.statusCode === 200 && apiResponse.data){
                        this.timeProUserList = apiResponse.data;
                    }else if(apiResponse.statusCode === 401){
                        comm.invalidSession(this);
                    }else{
                        comm.ApiErrorMessege(this,comm.unknowError,true);
                    }
                }
            },
            */
            async getPeriodConfig(){
                if(this.api && this.api.connection && this.api.apiRequest){
                    const apiResponse = await this.api.apiRequest.request.admin.getConfig();
                    if(apiResponse.statusCode === 200 && apiResponse.data){
                        this.periodConfig.saraly = apiResponse.data.period.saraly;
                        this.periodConfig.retire = apiResponse.data.period.retire;
                        this.periodConfig.yend = apiResponse.data.period.yend;
                        this.periodConfig.saralyView = comm.formatDate(new Date(apiResponse.data.period.saralyPay),"yyyy-mm-dd")
                        this.periodConfig.bounusView = comm.formatDate(new Date(apiResponse.data.period.bounusPay),"yyyy-mm-dd")
                        this.periodConfig.yendView = comm.formatDate(new Date(apiResponse.data.period.yendPay),"yyyy")
                    }else if(apiResponse.statusCode === 401){
                        comm.invalidSession(this);
                    }else{
                        comm.ApiErrorMessege(this,comm.unknowError);
                    }
                }
            },
            async updatePeriodConfig(){
                comm.LoadingOverlay(this,true)
                this.disPeriodUpBtn = true;
                const updateData = {
                    "saraly":parseFloat(this.periodConfig.saraly.toString()),
                    "retire":parseFloat(this.periodConfig.retire.toString()),
                    "yend":parseFloat(this.periodConfig.yend.toString()),
                }
                if(this.api && this.api.connection && this.api.apiRequest){
                    const apiResponse = await this.api.apiRequest.request.admin.setConfig({"period":updateData});
                    comm.LoadingOverlay(this,false);
                    this.disPeriodUpBtn = false;
                    if(apiResponse.statusCode === 200){
                        comm.SuccessMessege(this,this.text.messege.dbSccess);
                    }else if(apiResponse.statusCode === 401){
                        comm.invalidSession(this);
                    }else{
                        comm.ApiErrorMessege(this,comm.unknowError);
                    }
                }
            },
            async updatePeriodConfig2(){
                comm.LoadingOverlay(this,true)
                this.disPeriodUpBtn = true;
                const updateData = {
                    "saralyPay":(new Date(this.periodConfig.saralyView)).toISOString(),
                    "bounusPay":(new Date(this.periodConfig.bounusView)).toISOString(),
                    "yendPay":(new Date(this.periodConfig.yendView)).toISOString(),
                }
                if(this.api && this.api.connection && this.api.apiRequest){
                    const apiResponse = await this.api.apiRequest.request.admin.setConfig({"period":updateData});
                    comm.LoadingOverlay(this,false);
                    this.disPeriodUpBtn = false;
                    if(apiResponse.statusCode === 200){
                        comm.SuccessMessege(this,this.text.messege.dbSccess);
                    }else if(apiResponse.statusCode === 401){
                        comm.invalidSession(this);
                    }else{
                        comm.ApiErrorMessege(this,comm.unknowError);
                    }
                }
            },
            async addUser(){
                const addUserForm = this.$refs.addUserForm as vueRefForm;
                if(!addUserForm.validate()){
                    return false;
                }
                const ucode = this.addUserId.match(/^0+([1-9][0-9]+)/);
                if(!ucode){
                    return false;
                }
                const addUserId = ucode[1];
                //既存ユーザーにいないか確認
                let regUser = false;
                for(const v of this.userList){
                    if(v.userid === addUserId){
                        regUser = true;
                    }
                }
                if(regUser){
                    comm.WaringMessege(this,text.Text.messege.regedUser);
                    return false;
                }
                this.disAddUserBtn = true;
                this.warnMultiUser = false;
                if(this.api && this.api.connection && this.api.apiRequest){
                    const apiResponse = await this.api.apiRequest.request.admin.getTimeProUsers(this.addUserId);
                    this.disAddUserBtn = false;
                    if(apiResponse.statusCode === 200){
                        this.timeProUserList= apiResponse.data;
                        if(this.timeProUserList.length > 1){
                            this.warnMultiUser = true;
                            this.addUserInfo = {
                                "userId":"",
                                "empCode":"",
                                "userName":"",
                                "depnameShrt":"",
                                "depertment":"",
                                "depcode":"",
                                "password":"",
                            }
                            this.selectUsers = [];
                            for(const i in this.timeProUserList){
                                this.selectUsers.push({
                                    "value":i,
                                    "text":this.timeProUserList[i].name
                                });
                            }
                            this.digAddUserConf = true;
                        }else if(this.timeProUserList.length === 1){
                            const addUser = this.timeProUserList[0];
                            this.addUserInfo = {
                                "userId":addUserId,
                                "empCode":addUser.empcode,
                                "userName":addUser.name.trimEnd(),
                                "depnameShrt":addUser.depnameShrt?addUser.depnameShrt.trimEnd():null,
                                "depertment":addUser.depname?addUser.depname.trimEnd():null,
                                "depcode":addUser.depCode,
                                "password":"",
                            }
                            this.digAddUserConf = true;
                        }else{
                            comm.WaringMessege(this,this.text.messege.userNotfound);
                        }
                    }else if(apiResponse.statusCode === 401){
                        comm.invalidSession(this);
                    }else{
                        comm.ApiErrorMessege(this,comm.unknowError);
                    }
                }
            },
            selectUser(){
                if(this.selectUserNo){
                    this.addUserInfo = {
                        "userId":this.addUserId,
                        "empCode":this.timeProUserList[this.selectUserNo].empcode,
                        "userName":this.timeProUserList[this.selectUserNo].name.trimEnd(),
                        "depnameShrt":null,
                        "depertment":null,
                        "depcode":null,
                        "password":"",
                    }
                    const depname = this.timeProUserList[this.selectUserNo].depname;
                    if(typeof depname === "string"){
                        this.addUserInfo.depertment = depname.trimEnd();
                    }
                }
            },
            async addUserExec(){
                comm.LoadingOverlay(this,true);
                if(this.api && this.api.connection && this.api.apiRequest){
                    const apiResponse = await this.api.apiRequest.request.admin.addUser(this.addUserInfo.empCode);
                    comm.LoadingOverlay(this,false);
                    if(apiResponse.statusCode === 200){
                        if(apiResponse.data.userid && apiResponse.data.password){
                            this.addUserInfo.password = apiResponse.data.password;
                            this.digAddUserConf = false;
                            this.digPassword = true;
                            this.getUserList();
                        }else{
                            comm.WaringMessege(this,this.text.messege.addUserColition);
                        }
                    }else if(apiResponse.statusCode === 401){
                        comm.invalidSession(this);
                    }else{
                        comm.ApiErrorMessege(this,comm.unknowError);
                    }
                }
            },
            async printPassword () {
                comm.LoadingOverlay(this,true);
                if(this.api && this.api.connection && this.api.apiRequest){
                    const apiResponse = await this.api.apiRequest.request.pdf.password({
                        userid:this.addUserInfo.userId,
                        name:this.addUserInfo.userName,
                        depname:this.addUserInfo.depertment||"",
                        password:this.addUserInfo.password,
                    });
                    comm.LoadingOverlay(this,false);
                    if(apiResponse.statusCode === 200){
                        if(apiResponse.data.status && apiResponse.data.pdfdata){
                            const pdfData = await fetch(`data:application/pdf;base64,${apiResponse.data.pdfdata.data}`);
                            window.open(URL.createObjectURL(await pdfData.blob()));
                        }else{
                            comm.ApiErrorMessege(this,comm.unknowError);
                        }
                    }else if(apiResponse.statusCode === 401){
                        comm.invalidSession(this);
                    }else{
                        comm.ApiErrorMessege(this,comm.unknowError);
                    }
                }
            },
            async resetPassword(item?:type.apiResponseData_user){
                if(!item && this.userMenu.userItem){
                    item = this.userMenu.userItem;
                }
                if(!item){
                    return false;
                }
                if(this.api && this.api.connection && this.api.apiRequest){
                    const apiResponse = await this.api.apiRequest.request.admin.getTimeProUsers(item.empcode);
                    if(apiResponse.statusCode === 200){
                        const timeProUser = apiResponse.data.length === 1?apiResponse.data[0]:null;
                        if(timeProUser){
                            const userDetail = await this.api.apiRequest.request.admin.getUser(timeProUser.empcode);
                            if(userDetail.statusCode === 200){
                                this.addUserInfo.depertment = userDetail.data[0].depname;
                                this.addUserInfo.userId = userDetail.data[0].userid;
                                this.addUserInfo.userName = userDetail.data[0].username;
                                this.digPasswordRest = true;
                            }else if(userDetail.statusCode === 401){
                                comm.invalidSession(this);
                            }else{
                                comm.ApiErrorMessege(this,comm.unknowError);
                            }
                        }
                    }else if(apiResponse.statusCode === 401){
                        comm.invalidSession(this);
                    }else{
                        comm.ApiErrorMessege(this,comm.unknowError);
                    }
                }
            },
            async resetPasswordExec(){
                comm.LoadingOverlay(this,true);
                if(this.api && this.api.connection && this.api.apiRequest){
                    const resetpasswprd = await this.api.apiRequest.request.admin.resetpassword(this.addUserInfo.userId);
                    comm.LoadingOverlay(this,false);
                    if(resetpasswprd.statusCode === 200 && resetpasswprd.data.key){
                        this.addUserInfo.password = resetpasswprd.data.key;
                        this.digPasswordRest = false;
                        this.digPassword = true;
                    }else if(resetpasswprd.statusCode === 401){
                        comm.invalidSession(this);
                    }else{
                        comm.ApiErrorMessege(this,comm.unknowError);
                    }
                }
            },
            matchUser(){
                this.digMatchuserWarrning = true;
            },
            async execMatchUser(){
                this.digMatchuserWarrning = false;
                comm.LoadingOverlay(this,true);
                if(this.api && this.api.connection && this.api.apiRequest){
                    const resetpasswprd = await this.api.apiRequest.request.admin.refreshTimeProUsers();
                    comm.LoadingOverlay(this,false);
                    if(resetpasswprd.statusCode === 200){
                        if(resetpasswprd.data){
                            comm.SuccessMessege(this,this.text.messege.dbSccess);
                            this.getUserList();
                        }else{
                            comm.ApiErrorMessege(this,comm.unknowError);
                        }
                    }else if(resetpasswprd.statusCode === 401){
                        comm.invalidSession(this);
                    }else{
                        comm.ApiErrorMessege(this,comm.unknowError);
                    }
                }
            },
            userListMenu(e:MouseEvent,a:DataTableItemProps){
                e.preventDefault();
                this.userMenu.main = true;
                this.userMenu.x = e.clientX;
                this.userMenu.y = e.clientY;
                this.userMenu.userItem = a.item;
            },
            setAlias(){
                this.addUserInfo.userId = "";
                this.addUserInfo.userName = "";
                this.addUserInfo.empCode = "";
                this.addUserInfo.depertment = "";
                this.addUserInfo.password = "";
                this.digMigration = true;
                this.disMigBtn = true;
                this.aliUserId = "";
            },
            setfixName(){
                this.fixName = this.userMenu.userItem.username;
                this.digFixName = true;
            },
            async fixNameExec(set:boolean){
                if(!this.fixName){
                    return false;
                }
                comm.LoadingOverlay(this,true);
                if(this.api && this.api.connection && this.api.apiRequest){
                    const reqPram:SalaAPI_ModUser_req = {
                        "userName":`${set?'#':''}${this.fixName}`,
                    };
                    const apiResponse = await this.api.apiRequest.request.admin.modUser(this.userMenu.userItem.userid,reqPram);
                    comm.LoadingOverlay(this,false);
                    if(apiResponse.statusCode === 200 && apiResponse.data){
                        comm.SuccessMessege(this,this.text.messege.dbSccess);
                        this.digFixName = false;
                    }else if(apiResponse.statusCode === 401){
                        comm.invalidSession(this);
                    }else{
                        comm.ApiErrorMessege(this,comm.unknowError);
                    }
                }
            },
            async getAliasUserInfo(){
                if(!this.aliUserId){
                    return false;
                }
                const addUserForm = this.$refs.aliasUserForm as vueRefForm;
                if(!addUserForm.validate()){
                    return false;
                }
                comm.LoadingOverlay(this,true);
                if(this.api && this.api.connection && this.api.apiRequest){
                    const apiResponse = await this.api.apiRequest.request.admin.getTimeProUsers(this.aliUserId)
                    comm.LoadingOverlay(this,false);
                    if(apiResponse.statusCode === 200 && apiResponse.data){
                        const timeProUserList = apiResponse.data;
                        if(timeProUserList.length > 0){
                            const uCode =this.aliUserId.match(/^0+([1-9][0-9]+)/);
                            if(!uCode || typeof uCode[1] !=="string"){
                                comm.ApiErrorMessege(this,comm.unknowError);
                                return false;
                            }
                            this.addUserInfo.depertment = timeProUserList[0].depname;
                            this.addUserInfo.userId = uCode[1];
                            this.addUserInfo.empCode = timeProUserList[0].empcode;
                            this.addUserInfo.depertment = timeProUserList[0].depname;
                            this.addUserInfo.userName = timeProUserList[0].name;
                            this.disMigBtn = false;
                        }
                    }else if(apiResponse.statusCode === 401){
                        comm.invalidSession(this);
                    }else{
                        comm.ApiErrorMessege(this,comm.unknowError);
                    }
                }
            },
            async migraUserExec(){
                comm.LoadingOverlay(this,true);
                if(this.api && this.api.connection && this.api.apiRequest){
                    const reqPram:SalaAPI_ModUser_req = {
                        "userId":this.addUserInfo.userId,
                        "empCode":this.addUserInfo.empCode,
                        "alias":this.userMenu.userItem.empcode,
                    };
                    const apiResponse = await this.api.apiRequest.request.admin.modUser(this.userMenu.userItem.userid,reqPram);
                    comm.LoadingOverlay(this,false);
                    if(apiResponse.statusCode === 200 && apiResponse.data){
                        comm.SuccessMessege(this,this.text.messege.dbSccess);
                        this.getUserList();
                        this.digMigration = false;
                    }else if(apiResponse.statusCode === 401){
                        comm.invalidSession(this);
                    }else{
                        comm.ApiErrorMessege(this,comm.unknowError);
                    }
                }
            },
            setViewItems(){
                this.viewConfig.selectItem = null;
                this.viewConfig.selectList = [
                    {"text":this.text.payColmun.salary,"value":"Pay"},
                    {"text":this.text.payColmun.bonus,"value":"Bounus"},
                    {"text":this.text.yendAdj,"value":"YEndCab"},
                    {"text":this.text.withholdingTax,"value":"YEndTax"}
                ]
                this.formConfig.selectItem = null;
                this.formConfig.selectList = [
                {"text":this.text.payColmun.salary,"value":"Pay"},
                    {"text":this.text.payColmun.bonus,"value":"Bounus"},
                    {"text":this.text.yendAdj,"value":"YEndCab"},
                    {"text":this.text.withholdingTax,"value":"YEndTax"}
                ]
            },
            selectViewItem(){
                this.viewConfig.disUpdateBtn = true;
                this.getViewCfg();
            },
            async getViewCfg(){
                if(!this.viewConfig.selectItem){
                    this.viewConfig.selectItem = null;
                    return false;
                }
                let _keyCounter=0;
                comm.LoadingOverlay(this,true);
                if(this.api && this.api.connection && this.api.apiRequest){
                    const apiResponse = await this.api.apiRequest.request.admin.getViewConfig(this.viewConfig.selectItem);
                    comm.LoadingOverlay(this,false);
                    if(apiResponse && apiResponse.statusCode === 200 && apiResponse.data){
                        this.viewConfig.formRender = true;
                        //@ts-ignore
                        const cfgs:Array<ViewDeginDetail>|null = apiResponse.data.curCfg;
                        if(!cfgs){
                            return;
                        }
                        _keyCounter++;
                        for(const item of cfgs){
                            _keyCounter++;
                            item._key = _keyCounter;
                            for(const subItem of item.cards){
                                _keyCounter++;
                                subItem._key = _keyCounter;
                                if(subItem.calc){
                                    subItem._calc = true;
                                    if(typeof subItem.calc?.itemCode === "number"){
                                        subItem.calc._def = true;
                                    }else{
                                        subItem.calc._def = false;
                                    }
                                    if(subItem.calc.calc){
                                        subItem.calc._calc = true;
                                    }else{
                                        subItem.calc._calc = false;
                                    }
                                }else{
                                    subItem._calc = false;
                                    subItem.calc = {"type":null};
                                }
                                if(!subItem.calc.value){
                                    subItem.calc = Object.assign(subItem.calc,{"value":{"t":"","f":""}});
                                }
                                if(subItem.children){
                                    subItem._child = true;
                                    for(const childItem of subItem.children){
                                        _keyCounter++;
                                        childItem._key = _keyCounter;
                                        if(childItem.calc){
                                            childItem._calc = true;
                                            if(typeof childItem.calc.itemCode === "number"){
                                                childItem.calc._def = true;
                                            }else{
                                                childItem.calc._def = false;
                                            }
                                        }else{
                                            childItem._calc = false;
                                            childItem.calc = {"type":null};
                                        }
                                        if(!childItem.calc.value){
                                            childItem.calc = Object.assign(childItem.calc,{"value":{"t":"","f":""}});
                                        }
                                    }
                                }else{
                                    subItem._child = false;
                                }
                            }
                        }
                        this.viewConfig.curCfg = cfgs;
                        this.viewConfig.tpDefitemName = [];
                        const tableItem = apiResponse.data.tableItmes;
                        if(tableItem){
                            for(const v of tableItem){
                                this.viewConfig.tpDefitemName.push({
                                    "value":v.itemCode,
                                    "text":v.itenName,
                                });
                            }
                        }
                    }else if(apiResponse && apiResponse.statusCode === 401){
                        comm.invalidSession(this);
                    }else{
                        this.viewConfig.selectItem = null;
                        comm.LoadingOverlay(this,false);
                        this.viewConfig.formRender = false;
                        this.viewConfig.disUpdateBtn = false;
                    }
                }
                this.sortViewOrder();
                this.viewConfig.keyCounter = _keyCounter;
            },
            viewUpdate(){
                this.viewConfig.disUpdateBtn = true;
                setTimeout(this.viewUpdateExec,10);
            },
            async viewUpdateExec(){
                comm.LoadingOverlay(this,true);
                const _data = [] as viewDegin;
                if(!this.viewConfig.selectItem){return null}
                for(const item of Object.entries(this.viewConfig.curCfg)){
                    const _cards = [] as Array<type.viewDeginCard>;
                    delete item[1]._key;
                    for(const card of Object.entries(item[1].cards)){
                        delete card[1]._key;
                        let _card = {
                            "title":card[1].title,
                        } as type.viewDeginCard;
                        if(card[1]._child && card[1].children){
                            let _child = null as null|type.viewDeginCardChild;
                            for(const child of Object.entries(card[1].children)){
                                delete child[1]._key;
                                _child = child[1].itemCode?{
                                    "title":child[1].title,
                                    "itemCode":child[1].itemCode,
                                }:null;
                                if(_child && child[1]._calc && child[1].calc){
                                    _child.calc = {
                                        "type":child[1].calc.type
                                    }
                                    if(child[1].calc.type === "=" || child[1].calc.type === "?"){
                                        _child.calc.value = child[1].calc.value;
                                    }
                                    if(child[1].calc.type === "=" || child[1].calc._def && typeof child[1].calc.itemCode === "number"){
                                        _child.calc.itemCode = child[1].calc.itemCode;
                                    }else if(typeof child[1].calc.num === "string"){
                                        _child.calc.num = parseFloat(child[1].calc.num)
                                    }else if(typeof child[1].calc.num === "number"){
                                        _child.calc.num = child[1].calc.num;
                                    }else{
                                        delete _child.calc;
                                    }
                                    if(child[1].calc._calc && child[1].calc.calc && _child.calc){
                                        _child.calc.calc = {
                                            "type":child[1].calc.calc.type,
                                        }
                                        if(child[1].calc.calc.type === "=" || child[1].calc.calc.type === "?"){
                                            _child.calc.calc.value = child[1].calc.calc.value;
                                        }
                                        if(child[1].calc.calc.type === "=" || child[1].calc.calc._def && typeof child[1].calc.calc.itemCode === "number"){
                                            _child.calc.calc.itemCode = child[1].calc.calc.itemCode;
                                        }else if(typeof child[1].calc.calc.num === "string"){
                                            _child.calc.calc.num = parseFloat(child[1].calc.calc.num);
                                        }else if(typeof child[1].calc.calc.num === "number"){
                                            _child.calc.calc.num = child[1].calc.calc.num;
                                        }else{
                                            delete _child.calc.calc;
                                        }
                                    }
                                }
                                if(!_card.children){
                                    _card.children = [];
                                }
                                _child && _card.children.push(_child)
                            }
                        }else{
                            if(!card[1].itemCode){
                                continue;
                            }
                            _card.itemCode = card[1].itemCode;
                            if(card[1]._calc && card[1].calc){
                                _card.calc = {
                                    "type":card[1].calc.type
                                }
                                if(card[1].calc.type === "=" || card[1].calc.type === "?"){
                                    _card.calc.value = card[1].calc.value;
                                }
                                if(card[1].calc.type === "=" || card[1].calc._def && typeof card[1].calc.itemCode === "number"){
                                    _card.calc.itemCode = card[1].calc.itemCode;
                                }else if(typeof card[1].calc.num === "string"){
                                    _card.calc.num = parseFloat(card[1].calc.num);
                                }else if(typeof card[1].calc.num === "number"){
                                    _card.calc.num = card[1].calc.num;
                                }else{
                                    delete _card.calc;
                                }
                                if(card[1].calc._calc && card[1].calc.calc && _card.calc){
                                    _card.calc.calc = {
                                        "type":card[1].calc.calc.type,
                                    }
                                    if(card[1].calc.calc.type === "=" || card[1].calc.calc.type === "?"){
                                        _card.calc.value = card[1].calc.value;
                                    }
                                    if(card[1].calc.calc.type === "=" || card[1].calc.calc._def && typeof card[1].calc.calc.itemCode === "number"){
                                        _card.calc.calc.itemCode = card[1].calc.calc.itemCode;
                                    }else if(typeof card[1].calc.calc.num === "string"){
                                        _card.calc.calc.num = parseFloat(card[1].calc.calc.num);
                                    }else if(typeof card[1].calc.calc.num === "number"){
                                        _card.calc.calc.num = card[1].calc.calc.num;
                                    }else{
                                        delete _card.calc.calc;
                                    }
                                }
                            }
                        }
                        _cards.push(_card);
                    }
                    _data.push({"title":item[1].title,"cards":_cards,"order":0});
                }
                comm.LoadingOverlay(this,false);
                if(this.api && this.api.connection && this.api.apiRequest){
                    const apiResponse = await this.api.apiRequest.request.admin.updateViewConfig(this.viewConfig.selectItem,_data);
                    comm.LoadingOverlay(this,false);
                    this.disPeriodUpBtn = false;
                    if(apiResponse && apiResponse.statusCode === 200){
                        comm.SuccessMessege(this,this.text.messege.dbSccess);
                        setTimeout(this.getViewCfg,10);
                    }else if(apiResponse && apiResponse.statusCode === 401){
                        comm.invalidSession(this);
                    }else{
                        comm.ApiErrorMessege(this,comm.unknowError);
                    }
                }
            },
            removeViewItem(tgtKey:number|undefined){
                if(typeof tgtKey !== "number"){
                    return;
                }
                this.viewConfig.curCfg = this.viewConfig.curCfg.filter(root=>{
                    if(root._key !== tgtKey){return true}else{return false}
                });
                for(const rootItems of this.viewConfig.curCfg){
                    if(rootItems.cards){
                        rootItems.cards = rootItems.cards.filter(card=>{
                            if(card._key !== tgtKey){return true}else{return false}
                        });
                        for(const card of rootItems.cards){
                            if(card.children){
                                card.children = card.children.filter(child=>{
                                    if(child._key !== tgtKey){return true}else{return false}
                                });
                            }
                        }
                    }
                }
            },
            addViewItem(tgtKey?:number){
                let _keyCounter = this.viewConfig.keyCounter;
                if(!tgtKey){
                    _keyCounter++;
                    const maxOrder = this.viewConfig.curCfg.reduce((acc,cur)=>{
                        if(!acc.order || !cur.order){return acc}
                        return acc.order>cur.order?acc:cur
                    }).order??0;
                    this.viewConfig.curCfg.push({
                        "title":"",
                        "cards":[],
                        "_key":_keyCounter,
                        "order":maxOrder+1,
                        });
                }
                for(const rootItem of this.viewConfig.curCfg){
                    if(rootItem._key === tgtKey){
                        _keyCounter++;
                        const maxOrder = rootItem.cards.length>0?rootItem.cards.reduce((acc,cur)=>{
                            if(!acc.order || !cur.order){return acc}
                            return acc.order>cur.order?acc:cur
                        }).order??0:0;
                        rootItem.cards.push({
                            "title":"",
                            "calc":{
                                "type":"+",
                                "value":{"t":"","f":""},
                            },
                            "_key":_keyCounter,
                            "order":maxOrder+1,
                        });
                    }
                    for(const card of rootItem.cards){
                        if(card._key === tgtKey){
                            _keyCounter++;
                            if(!card.children){
                                card.children = [];
                            }
                            const maxOrder = card.children.length>0?(card.children.reduce((acc,cur)=>{
                                if(!acc.order || !cur.order){return acc}
                                return acc.order>cur.order?acc:cur
                            }).order??0):0;
                            card.children.push({
                                "title":"",
                                "itemCode":undefined,
                                "calc":{
                                    "type":"+",
                                    "value":{"t":"","f":""},
                                },
                                "_key":_keyCounter,
                                "order":maxOrder+1,
                            });
                            card._child = true;
                        }
                    }
                }
                this.viewConfig.curCfg.splice(this.viewConfig.curCfg.length);
                this.viewConfig.keyCounter = _keyCounter;
                this.sortViewOrder();
            },
            refreshViewConfig(){
                this.viewConfig.curCfg.splice(this.viewConfig.curCfg.length);
            },
            sortViewOrder(){
                this.viewConfig.curCfg.sort((a,b)=>{
                    if(!a.order || !b.order){return 0;}
                    if(a.order<b.order){return -1}
                    if(a.order>b.order){return 1}
                    return 0;
                });
                for(const rootItem of this.viewConfig.curCfg){
                    rootItem.cards.sort((a,b)=>{
                        if(!a.order || !b.order){return 0;}
                        if(a.order<b.order){return -1}
                        if(a.order>b.order){return 1}
                        return 0;
                    });
                }
                for(const rootItem of this.viewConfig.curCfg){
                    for(const card of rootItem.cards){
                        if(card.children){
                            card.children.sort((a,b)=>{
                                if(!a.order || !b.order){return 0;}
                                if(a.order<b.order){return -1}
                                if(a.order>b.order){return 1}
                                return 0;
                            });
                        }
                    }
                }
            },
            moveOrder(dir:-1|1,tgtKey:number|undefined){
                if(typeof tgtKey !== "number"){
                    return;
                }
                const vList = this.viewConfig.curCfg;
                const _sortBuf={
                    tgtGroup:[] as Array<type.viewDeginCard>,
                    tgtOrder:0,
                }
                for(const rootItem of vList){
                    for(const card of rootItem.cards){
                        if(card._key === tgtKey && card.order){
                            //@ts-ignore
                            _sortBuf.tgtGroup = rootItem.cards;
                            _sortBuf.tgtOrder = card.order;
                        }
                        if(card.children){
                            for(const child of card.children){
                                if(child._key === tgtKey && child.order){
                                    //@ts-ignore
                                    _sortBuf.tgtGroup = card.children;
                                    _sortBuf.tgtOrder = child.order;
                                    break;
                                }
                            }
                        }
                    }
                    if(rootItem._key === tgtKey && rootItem.order){
                        //@ts-ignore
                        _sortBuf.tgtGroup = vList;
                        _sortBuf.tgtOrder = rootItem.order;
                        break;
                    }
                }
                for(const sortItem of _sortBuf.tgtGroup){
                    if(dir>0){
                        if(sortItem.order === _sortBuf.tgtOrder && sortItem._key === tgtKey){
                            sortItem.order++;
                        }
                        if(sortItem.order === _sortBuf.tgtOrder+1 && sortItem._key !== tgtKey){
                            sortItem.order--;
                        }
                    }
                    if(dir<0){
                        if(sortItem.order === _sortBuf.tgtOrder && sortItem._key === tgtKey){
                            sortItem.order--;
                        }
                        if(sortItem.order === _sortBuf.tgtOrder-1 && sortItem._key !== tgtKey){
                            sortItem.order++;
                        }
                    }
                }
                this.sortViewOrder();
            },
            selectFormItem(){
                this.formConfig.disUpdateBtn = true;
                this.getFormCfg();
            },
            async getFormCfg(){
                if(!this.formConfig.selectItem){
                    this.formConfig.selectItem = null;
                    return false;
                }
                comm.LoadingOverlay(this,true);
                if(this.api && this.api.connection && this.api.apiRequest){
                    const apiResponse = await this.api.apiRequest.request.admin.getFormConfig(this.formConfig.selectItem);
                    comm.LoadingOverlay(this,false);
                    if(apiResponse && apiResponse.statusCode === 200){
                        const apiData = apiResponse.data;
                        if(apiData.colomun){
                            this.formConfig.keyCounter = 0;
                            let count=0;
                            this.formConfig.colomun = apiData.colomun.map(v=>{
                                count++;
                                const r = v as unknown as type.db_TB_FORM_COLUMN&{_preView:string|number,_options:boolean,_key:number};
                                r._key = count;
                                r._preView = count;
                                if(r.OPTIONS){
                                    r._options = true;
                                    let cnt = 0;
                                    for(const opt of r.OPTIONS){
                                        opt._def = typeof opt.itemCode==="number"?true:false;
                                        if(cnt>0){
                                            r.OPTIONS[cnt-1]._calc = true;
                                        }
                                        cnt++;
                                    }
                                }else{
                                    r._options = false;
                                    r.OPTIONS = [{"type":"+","value":{"t":"","f":""},"_calc":false}];
                                }
                                return r;
                            });
                            this.formConfig.keyCounter = count;
                        }
                        this.formConfig.form = apiData.form?apiData.form:null;
                        this.formConfig.fromView = true;
                        const defs = apiResponse.data.tableItmes;
                        if(defs){
                            for(const v of defs){
                                this.formConfig.tpDefitemName.push({
                                    "value":v.itemCode,
                                    "text":v.itenName,
                                });
                            }
                        }
                        this.formConfig.disUpdateBtn = false;
                    }else if(apiResponse && apiResponse.statusCode === 401){
                        comm.invalidSession(this);
                    }else{
                        this.viewConfig.selectItem = null;
                        comm.LoadingOverlay(this,false);
                        this.viewConfig.formRender = false;
                        this.viewConfig.disUpdateBtn = false;
                    }
                }
            },
            async getPdf(){
                if(!this.formConfig.selectItem){return false;}
                if(this.api && this.api.connection && this.api.apiRequest){
                    const apiResponse = await this.api.apiRequest.request.admin.getFormPdf(this.formConfig.selectItem);
                    if(apiResponse && apiResponse.statusCode === 200 && apiResponse.data){
                        window.open(URL.createObjectURL(new Blob([apiResponse.data],{"type":"application/pdf"})));
                    }else if(apiResponse && apiResponse.statusCode === 401){
                        comm.invalidSession(this);
                    }else{
                        comm.WaringMessege(this,this.text.messege.dontGetFile);
                    }
                }
            },
            selectFile(item:File){
                this.disUploadBtn = true;
                if(item){
                    this.uploadFile = item;
                    this.disUploadBtn = false;
                }
            },
            async uploadPdf(){
                comm.LoadingOverlay(this,true);
                if(this.uploadFile){
                    const pdfdata = await this.uploadFile.arrayBuffer();
                    if(this.api && this.api.connection && this.api.apiRequest){
                        const apiResponse = await this.api.apiRequest.request.admin.uploadFormPdf(new Uint8Array(pdfdata));
                        comm.LoadingOverlay(this,false);
                        if(apiResponse && apiResponse.statusCode === 200 && apiResponse.data){
                            this.disAppPdfBtn = false;
                            this.disUploadBtn = true;
                            this.tempPdfFile = apiResponse.data;
                        }else if(apiResponse && apiResponse.statusCode === 401){
                            comm.invalidSession(this);
                        }else{
                            comm.WaringMessege(this,this.text.messege.dontGetFile);
                        }
                    }
                }
            },
            disTempPdf(){
                this.tempPdfFile = "";
                this.tempPdfObj = null;
                this.disAppPdfBtn = true;
            },
            async formPreview(){
                if(!this.formConfig.selectItem){
                    this.formConfig.selectItem = null;
                    return false;
                }
                comm.LoadingOverlay(this,true);
                const formItem = this.makeFormData();
                if(this.api && this.api.connection && this.api.apiRequest){
                    const apiResponse = await this.api.apiRequest.request.pdf.formPreview(this.formConfig.selectItem,{
                        "previewFile":this.tempPdfFile,
                        "items":formItem.item,
                        "values":formItem.data,
                    });
                    comm.LoadingOverlay(this,false);
                    if(apiResponse && apiResponse.statusCode === 200 && apiResponse.data.pdfdata){
                        comm.openPdfNewWindow(apiResponse.data.pdfdata.data);
                    }else if(apiResponse && apiResponse.statusCode === 401){
                        comm.invalidSession(this);
                    }else{
                        comm.WaringMessege(this,this.text.messege.dontGetFile);
                    }
                }
            },
            removeFormItem(itemKey:number){
                this.formConfig.colomun = this.formConfig.colomun.filter(v=>{
                    if(v._key !== itemKey){return true}else{return false}
                });
            },
            addFormItem(){
                let count = this.formConfig.keyCounter;
                count++;
                    this.formConfig.colomun.push({
                        "FORM_ID":/*this.formConfig.selectItem?this.formConfig.selectItem:*/0,
                        "POS_X":0,
                        "POS_Y":0,
                        "WIDTH":0,
                        "HEIGHT":0,
                        "FONT_SIZE":0,
                        "TABLE_ITEM_NO":null,
                        "ALIGN":null,
                        "_key":count,
                        "_options":false,
                        "OPTIONS":[{"type":"+","value":{"t":"","f":""},"num":undefined}],
                        "_preView":count,
                    });
                this.formConfig.keyCounter = count;
            },
            formUpdate(){
                this.formConfig.disUpdateBtn = true;
                setTimeout(this.formUpdateExec,10);
            },
            makeFormData(){
                const _data = [] as Array<SalaAPI_column_Res>;
                const _items = {} as {[itemCode:number]:string|number};
                for(const _clm of this.formConfig.colomun){
                    if(_clm._options && _clm.OPTIONS){
                        _clm.OPTIONS = _clm.OPTIONS.map(v=>{
                            if(typeof v.num === "string"){
                                v.num = parseFloat(v.num);
                            }
                            return v;
                        });
                    }
                    _data.push({
                        "FORM_ID":parseInt(_clm.FORM_ID.toString(),10),
                        "POS_X":parseFloat(_clm.POS_X.toString()),
                        "POS_Y":parseFloat(_clm.POS_Y.toString()),
                        "WIDTH":parseFloat(_clm.WIDTH.toString()),
                        "HEIGHT":parseFloat(_clm.HEIGHT.toString()),
                        "FONT_SIZE":parseFloat(_clm.FONT_SIZE.toString()),
                        "ALIGN":_clm.ALIGN,
                        "TABLE_ITEM_NO":_clm.TABLE_ITEM_NO,
                        "OPTIONS":(_clm._options&&_clm.OPTIONS)?_clm.OPTIONS.map(v=>{
                            let _ = {
                                "type":v.type,
                                "num":v.num,
                                "itemCode":v.itemCode,
                                "value":v.value,
                            }
                            if(typeof _.num === "undefined"){
                                delete _.num;
                            }
                            if(typeof _.itemCode === "undefined"){
                                delete _.itemCode;
                            }
                            if(typeof _.value === "undefined"){
                                delete _.value;
                            }
                            return _;
                        }):null,
                    });
                    if(typeof _clm.TABLE_ITEM_NO === "number"){_items[_clm.TABLE_ITEM_NO] = _clm._preView;}
                }
                return {data:_data,item:_items};
            },
            async formUpdateExec(){
                if(!this.formConfig.selectItem){return false;}
                const formItem = this.makeFormData();
                comm.LoadingOverlay(this,true);
                if(this.api && this.api.connection && this.api.apiRequest){
                    const apiResponse = await this.api.apiRequest.request.admin.updateFormColumn(this.formConfig.selectItem,formItem.data,this.tempPdfFile);
                    comm.LoadingOverlay(this,false);
                    if(apiResponse && apiResponse.statusCode === 200 && apiResponse.data){
                        comm.SuccessMessege(this,this.text.messege.dbSccess);
                        setTimeout(this.getFormCfg,10);
                    }else if(apiResponse && apiResponse.statusCode === 401){
                        comm.invalidSession(this);
                    }else{
                        comm.WaringMessege(this,this.text.messege.dontGetFile);
                    }
                }
            },
            parentCallback(order:string){
                switch(order){
                    case "pageShow":
                        this.getUserList();
                        this.setViewItems();
                    break;
                    case "reset":
                        this.reset();
                    break;
                }
            },
            getToday(){
                return comm.formatDate(new Date(),'yyyy-mm-dd')
            },
            async getSalResings(){
                comm.LoadingOverlay(this,true);
                if(this.api && this.api.connection && this.api.apiRequest){
                    const apiResponse = await this.api.apiRequest.request.admin.getResignSalary();
                    comm.LoadingOverlay(this,false);
                    if(apiResponse && apiResponse.statusCode === 200 && apiResponse.data){
                        this.saralyResinList = [];
                        for(const rDetail of apiResponse.data){
                            const aDate = new Date(rDetail.ADATE);
                            const gengouA = comm.getGengou(aDate);
                            const rDate = new Date(rDetail.RDATE);
                            const gengouR = comm.getGengou(rDate);
                            const user = this.userList.find(v=>{if(v.userid===rDetail.USERID){return true}});
                            this.saralyResinList.push({
                                "userId":rDetail.USERID,
                                "userName":user?user.username:"",
                                "aDate":comm.strReplacePercentObject(this.text.resingForm.system.aDateFormat,{"gengou":gengouA?gengouA.name:"","year":gengouA?gengouA.year:"","month":aDate.getMonth()+1}),
                                "rDate":comm.strReplacePercentObject(this.text.resingForm.system.rDateFormat,{"gengou":gengouR?gengouR.name:"","year":gengouR?gengouR.year:"","month":rDate.getMonth()+1,"date":rDate.getDate()}),
                                "formatType":this.text.resingForm.system.formatType[rDetail.FROMAT]??"",
                                "jobLevel":"string",
                                "jobClass":"string",
                                "bJobClass":"string",
                                "uJobClass":"string",
                                "baseSal":"string",
                                "cutRate":"",
                                "continReword":"",
                                "manageReword":"",
                                "workReword":"",
                                "classReword":"",
                                "total":"",
                                "bBaseSal":"",
                                "bContinReword":"",
                                "bManageReword":"",
                                "bWorkReword":"string",
                                "bClassReword":"string",
                                "bTotal":"string",
                                "baseUp":"string",
                                "cBaseSal":"string",
                                "cContinReword":"string",
                                "cManageReword":"string",
                                "cWorkReword":"string",
                                "cClassReword":"string",
                                "cTotal":"string",
                                "cBaseUp":"string",
                                "untripDecer":"string",
                                "untripTotal":"string",
                                "fstPit":"string",
                                "fstUp1":"string",
                                "fstUp2":"string",
                                "fstTotal":"string",
                            });
                        }
                    }else if(apiResponse && apiResponse.statusCode === 401){
                        comm.invalidSession(this);
                    }else{
                        comm.WaringMessege(this,this.text.messege.dontGetFile);
                    }
                }
            },
            setUploadFile(item:File){
                this.uploadWarnFlg = false;
                if(!item){
                    this.disResignUploadBtn = true;
                    return false;
                }
                comm.LoadingOverlay(this,true);
                this.saralyResinUploadData = null;
                this.fileLoad(item);
            },
            async fileLoad(tgtFile:File){
                const fileReader = new FileReader();
                fileReader.onload = async (e) =>{
                    if(e.target && e.target.result && typeof e.target.result !== "string"){
                        this.saralyResinUploadBook = new exceljs.Workbook();
                        await this.saralyResinUploadBook.xlsx.load(e.target.result);
                        const _data = importSalaryResign(this.saralyResinUploadBook);
                        if(_data){
                            this.saralyResinUploadData = _data;
                            this.uploadWarnFlg = true;
                            this.uploadWarnMes = comm.strReplacePercentObject(this.text.messege.resing.uploadCount,{"count":_data.length});
                            this.uploadWarnTyp = "info";
                        }else{
                            this.uploadWarnFlg = true;
                            this.uploadWarnMes = this.text.messege.fileAnalazFail;
                            this.uploadWarnTyp = "warning";
                        }
                    }else{
                        this.uploadWarnFlg = true;
                        this.uploadWarnMes = this.text.messege.fileLoadFailed;
                        this.uploadWarnTyp = "error";
                    }
                    comm.LoadingOverlay(this,false);
                    this.chkUploadBtnEnable();
                }
                fileReader.readAsArrayBuffer(tgtFile);
            },
            chkUploadBtnEnable(){
                if(this.saralyResinDate.a && this.saralyResinDate.r && this.saralyResinUploadData){
                    this.disResignUploadBtn = false;
                }else{
                    this.disResignUploadBtn = true;
                }
            },
            resignUpload(){
                if(!this.saralyResinDate.a || !this.saralyResinDate.r || !this.saralyResinUploadData){
                    return false;
                }
                this.disResignUploadBtn = true;
                this.execResignUpload();
            },
            async execResignUpload(){
                if(!this.saralyResinDate.a || !this.saralyResinDate.r || !this.saralyResinUploadData){
                    return false;
                }
                if(this.api && this.api.connection && this.api.apiRequest){
                    const uploadData = this.saralyResinUploadData.map(v=>{
                        v.ADATE = (new Date(this.saralyResinDate.a)).toISOString();
                        v.RDATE = (new Date(this.saralyResinDate.r)).toISOString();
                        return v;
                    });
                    comm.LoadingOverlay(this,true);
                    this.resingXlsxDig.disCancl = true;
                    const btnTxt = this.resingXlsxDig.uploadbtntxt;
                    this.resingXlsxDig.uploadbtntxt = this.text.uploading;
                    const apiResponse = await this.api.apiRequest.request.admin.updateResignSalary(uploadData,this.resignOverwrite?"true":"false");
                    comm.LoadingOverlay(this,false);
                    this.resingXlsxDig.uploadbtntxt = btnTxt;
                    this.resingXlsxDig.disCancl = false;
                    this.disResignUploadBtn = false;
                    if(apiResponse && apiResponse.statusCode === 200 && apiResponse.data){
                        comm.SuccessMessege(this,this.text.messege.dbSccess);
                        this.restResinDigs();
                }else if(apiResponse && apiResponse.statusCode === 401){
                        comm.invalidSession(this);
                    }else{
                        comm.WaringMessege(this,this.text.messege.dontGetFile);
                    }
                }
            },
            async execResignDelete(){
                if(this.api && this.api.connection && this.api.apiRequest){
                    comm.LoadingOverlay(this,true);
                    const apiResponse = await this.api.apiRequest.request.admin.updateResignSalary([],"sync");
                    comm.LoadingOverlay(this,false);
                    if(apiResponse && apiResponse.statusCode === 200 && apiResponse.data){
                        comm.SuccessMessege(this,this.text.messege.dbSccess);
                        this.restResinDigs();
                    }else if(apiResponse && apiResponse.statusCode === 401){
                        comm.invalidSession(this);
                    }else{
                        comm.WaringMessege(this,this.text.messege.dontGetFile);
                    }
                }
            },
            async restResinDigs(){
                await this.getSalResings();
                this.digUploadResignList = false;
                this.digRemoveResignList = false;
            }
        }
    });
</script>
<style>
.hoverPointer:hover{
    cursor: pointer;
}
</style>
